module.exports = __webpack_public_path__ + "img/ARCADES_ET_BAIES_20s.42663a74.jpg";